<template>
  <div class="tips-section" :style="css">
    <Loading v-if="loading" />

    <v-container v-else class="py-10 py-sm-12 py-md-14 py-lg-16">
      <PagesTitle logoHeight="24px" :mod="mod"
        >Dicas para o Dia do Exame</PagesTitle
      >

      <v-row justify="center" class="mt-4">
        <v-col
          class="mt-4"
          cols="12"
          sm="6"
          md="4"
          v-for="({ img, title, text }, keyItems) in items"
          :key="keyItems"
        >
          <v-dialog v-model="dialog[keyItems]" max-width="800">
            <template v-slot:activator="{ on, attrs }">
              <div class="d-flex flex-column item" v-bind="attrs" v-on="on">
                <img
                  width="100%"
                  :src="files + img"
                  :alt="title"
                  class="d-block rounded-xl item-img"
                />
                <div
                  class="item-title d-flex justify-center align-center px-10"
                >
                  <span
                    class="
                      text-h6 text-sm-h5 text-md-h4
                      font-weight-bold
                      white--text
                      text-center
                    "
                  >
                    {{ title }}
                  </span>
                </div>
              </div>
            </template>

            <v-card class="item-dialog-card">
              <v-btn
                icon
                color="red"
                class="item-dialog-close"
                @click="closeDialog(keyItems)"
              >
                <v-icon>fas fa-times</v-icon>
              </v-btn>
              <v-card-title class="text-sm-h5 text-h6 font-weight-bold">
                {{ title }}
              </v-card-title>

              <v-card-text>
                <img
                  width="100%"
                  :src="files + img"
                  class="d-block"
                  :alt="title"
                />
                <div v-html="text" class="ck-content mt-5"></div>
              </v-card-text>
            </v-card>
          </v-dialog>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import PagesTitle from "../widgets/PagesTitle.vue";
import Loading from "../widgets/Loading.vue";

const _config = {
  mod: "pages-tips",
};

export default {
  props: {
    mod: {
      type: String,
      required: true,
    },
    color: {
      type: String,
      default: "",
    },
  },
  data: () => ({
    loading: true,
    items: [],
    dialog: [],
  }),
  mounted() {
    this.$rest(_config.mod)
      .get({
        id: this.mod,
        save: (state, data) => {
          this.items = data;
          this.dialog = Array(data.length).fill(false);
        },
      })
      .then(() => (this.loading = false));
  },
  methods: {
    closeDialog(index) {
      this.$set(this.dialog, index, false);
    },
  },
  computed: {
    css() {
      return {
        "--page-color": this.color,
      };
    },
  },
  components: {
    Loading,
    PagesTitle,
  },
};
</script>
<style lang="scss" scoped>
.tips-section {
  background-image: url(/img/tip-bg.svg);
  background-size: contain;
  background-position: bottom;
}
.item {
  height: 100%;
  position: relative;

  &-img {
    aspect-ratio: 362 / 187;
    object-fit: cover;
  }

  &-title {
    position: absolute;
    height: 100%;
    width: 100%;
    left: 0;
    top: 0;
    background-color: rgba(0, 0, 0, 0.3);
    border-radius: 24px;
  }
  &-dialog-close {
    position: absolute;
    right: 0px;
    top: 0px;
  }
}
</style>
